// import { faBold } from '@fortawesome/free-solid-svg-icons';
// import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
// const useStyles = makeStyles((theme) => ({
export const styles = (theme) => ({
  imgResponsive: {
    width: '100%',
  },
  img: {
    width: '100%',
  },
  title: {
    fontWeight: 'Bold',
  },
  time: {
    color: '#555',
  },
  ertitle: {
    fontWeight: 'Bold',
    color: '#ff0000',
  },
  ertime: {
    color: '#ff0000',
  },
  boxAccumulatHistory: {
    padding: theme.spacing(1),
    border: '1px solid #ccc',
    backgroundColor: 'white',
    height: 'max-content',
    minHeight: 'none',
  },
  dateTime: {
    fontSize: '0.9em',
    fontWeight: 600,
    color: grey[500],
    fontFamily: 'Kanit',
    textAlign: 'center',
  },
  titleBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 19,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(1),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1em',
    },
  },
  bodyBox: {
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.line.main}`,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    align: 'center',
    textAlign: 'center',
  },
  button: {
    marginRight: '2%',
    borderRadius: '5em',
    '&:hover': {
      backgroundColor: '#7C7C7C',
      color: '#ffffff',
    }
  },
  boxTopRadius: {
    border: '1px solid #ccc',
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    backgroundColor: 'white',
  },
  titleName: {
    fontFamily: 'Kanit',
    fontSize: 15,
    fontWeight: 500,
    padding: theme.spacing(1),
  },
  outlinedLeftPrimary: {
    height: '100%',
    borderRadius: 0,
    padding: '6px  16px',
    width: '100%',
    borderLeft: '1px solid #ccc',
    fontFamily: 'Kanit',
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      borderTop: '1px solid #ccc',
      borderLeft: 'none',
    },
  },
  outlinedPrimary: {
    height: '100%',
    borderRadius: 0,
    padding: '6px  16px',
    width: '100%',
    borderLeft: '1px solid #ccc',
    fontFamily: 'Kanit',
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      borderTop: '1px solid #ccc',
      padding: 16,
    },
  },
});
